import React, {lazy, Suspense} from 'react'

const CatholicNewsPageLazy = lazy(() =>
    import('./CatholicNewsPage')
)

const CatholicNewsPage = props => (
    <Suspense fallback={null}>
        <CatholicNewsPageLazy {...props} />
    </Suspense>
)

export default CatholicNewsPage
